/**
 * Where "show this agent's visits" links land in the visits panel
 * (filters sweep, 2026-10-14). The panel's search matches the registry
 * agent id, the visitor class and the user agent, never a display name,
 * and its default "All" chip leaves people out. So:
 *
 *   - people (plain browsers)  → the People chip, no search;
 *   - a registry agent         → search its agent id ("agent_openai_searchbot");
 *   - anything else            → its classifier name when it has one (best
 *                                effort: it often appears in the user agent),
 *                                else no filter.
 *
 * Before this, the Agents page sent the display name ("ChatGPT Search",
 * "Human visitors"), which matched nothing.
 */

import type { VisitSegmentFilter } from '@sill/types/api';

export interface VisitsLink {
  readonly q?: string;
  readonly segment?: VisitSegmentFilter;
}

export function visitsLinkFor(a: {
  readonly agent_id?: string | null;
  readonly visitor_class?: string | null;
  readonly category?: string | null;
  readonly inferred_name?: string | null;
}): VisitsLink {
  if (a.visitor_class === 'human_likely' || a.category === 'human') return { segment: 'people' };
  if (typeof a.agent_id === 'string' && a.agent_id.length > 0) return { q: a.agent_id };
  const name = a.inferred_name?.trim() ?? '';
  return name.length > 0 ? { q: name } : {};
}
